import { WizardConstants } from '@app/common/configurable-wizards';

export enum WizardSteps {
  UserKindSelect = 'UserKindSelect',
}

export const Constants: WizardConstants<WizardSteps> = {
  // eslint-disable-next-line i18next/no-literal-string
  I18N_NS: 'user-kind',
  WIZARD_NAME: 'UserKind',
  WIZARD_DEFAULT_STEP: WizardSteps.UserKindSelect,
};
